import React, { useEffect, useState } from 'react';
import { Button, Empty, Segmented, Spin, Tag } from 'antd';
import { EditOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { essayAPI } from '../../services/api';
import { Essay } from '../../types';
import StatusTag from '../../components/StatusTag';
import { getTopicFromEssay } from '../../utils/topicHelper';

const H5HistoryPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<string>('all');
  const [essays, setEssays] = useState<Essay[]>([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10, total: 0 });

  const fetchEssays = async (page = 1, append = false) => {
    setLoading(true);
    try {
      const response = await essayAPI.list({
        page,
        page_size: pagination.pageSize,
        status: status === 'all' ? undefined : status,
        sort_by: 'created_at',
        sort_order: 'desc',
      });
      const nextEssays = response.data.data || [];
      setEssays((prev) => (append ? [...prev, ...nextEssays] : nextEssays));
      setPagination((prev) => ({
        ...prev,
        page,
        total: response.data.total || nextEssays.length,
      }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEssays(1, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const hasMore = essays.length < pagination.total;

  return (
    <div className="h5-page">
      <section className="h5-history-actions">
        <Button type="primary" icon={<EditOutlined />} block onClick={() => navigate('/h5/essay/new')}>
          新建批改
        </Button>
      </section>

      <section className="h5-panel">
        <Segmented
          block
          value={status}
          onChange={(value) => setStatus(String(value))}
          options={[
            { label: '全部', value: 'all' },
            { label: '处理中', value: 'processing' },
            { label: '已完成', value: 'completed' },
            { label: '失败', value: 'failed' },
          ]}
        />

        <Spin spinning={loading && essays.length === 0}>
          {essays.length === 0 ? (
            <Empty className="h5-empty" description="暂无作文记录" />
          ) : (
            <div className="h5-essay-list h5-history-list">
              {essays.map((essay) => {
                const topic = getTopicFromEssay(essay);
                return (
                  <button
                    key={essay.id}
                    className="h5-essay-card"
                    onClick={() => navigate(`/h5/essay/${essay.id}/result`)}
                  >
                    <div>
                      <h3>{topic?.title || '未设置题目'}</h3>
                      <p>{essay.student?.name || '-'} · {essay.class?.name || '-'}</p>
                      <span>{essay.created_at ? new Date(essay.created_at).toLocaleString('zh-CN') : '-'}</span>
                    </div>
                    <div className="h5-essay-card-side">
                      {essay.correction?.total_score ? (
                        <Tag color="green">{essay.correction.total_score} 分</Tag>
                      ) : (
                        <StatusTag status={essay.status} />
                      )}
                      <RightOutlined />
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </Spin>

        {hasMore && (
          <Button block loading={loading} onClick={() => fetchEssays(pagination.page + 1, true)}>
            加载更多
          </Button>
        )}
      </section>
    </div>
  );
};

export default H5HistoryPage;
